module.exports = __webpack_public_path__ + "static/media/layout_single_active.c4ef4947.svg";